<div class="loader">
  @if (withLogo) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <div id="container">
      <img class="responsive" [src]="logo" src="" alt="">
    </div>
  } @else {
    <div id="containers">
      @if (withChargingText) {
        <ngx-ui-loader [loaderId]="'loader'" [hasProgressBar]="false" [fgsSize]="_fgsSize" [fgsType]="SPINNER.pulse" text="Cargando..."></ngx-ui-loader>
      } @else {
        <ngx-ui-loader [loaderId]="'loader'" [hasProgressBar]="false" [fgsSize]="_fgsSize" [fgsType]="SPINNER.pulse"></ngx-ui-loader>
      }
    </div>
  }
</div>
